export default __webpack_public_path__ + "static/media/pitikDance.271425a7.png";